import getRoles from "./getRoles"

export { getRoles }
const role = { getRoles }

export default role
